import type { DateTime } from "luxon";
import { createContext, useContext } from "react";

export type SelfSchedulingContextType = {
	isImportingSelfScheduling: boolean;
	toggleImportingSelfScheduling: () => Promise<void>;
	isDataInSelfSchedulingPeriod: (date: DateTime) => boolean;
	isLoading: boolean;
};

export const SelfSchedulingContext = createContext<SelfSchedulingContextType | undefined>(undefined);

export const useSelfScheduling = () => {
	const context = useContext(SelfSchedulingContext);
	if (!context) throw new Error("useSelfScheduling must be used within SelfSchedulingProvider");

	return context;
};
